import
  React, {
  useEffect,
  useRef,
  useState
}	from 'react';

import
  styled
from 'styled-components';

import
  PropTypes
from 'prop-types';

import {
  HContainer
} from '@vodacom/web-common';

import {
  ItemCard
} from './ItemCard';

import {
  CustomColors,
  Icons
} from '../../../../constants';

import {
  isEqual
} from 'helpers';

const Container = styled(HContainer)`
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ItemSelector = (props) => {

  const [ state, setState ] = useState({
    activeItem: props.defaultItem
  });

  const myRef = useRef(null);

  useEffect(() => {
    myRef?.current?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  }, [ props.defaultItem ]);

  const onItemClick = (value) => {

    if (isEqual(value, state.activeItem)) {
      return;
    }

    setState(prevState => ({
      ...prevState,
      activeItem: value
    }));

    props.onChange?.(value);
  };

  const itemList = [];

  for (let i = 0; i < props.items.length; i ++) {

    let item = props.items[i];

    if (!item || !Object.keys(item)?.length) {
      continue;
    }

    const isActive = isEqual(item.value, state.activeItem);

    itemList.push(

      <ItemCard
        refs={isActive ? myRef : null}
        boxShadow={props.boxShadow}
        border={isActive ? props.activeBorder : props.inActiveBorder}
        key={`selector-card-${item.value}`}
        onClick={() => onItemClick(item.value)}
        iconUrl={item.iconUrl || Icons.VoucherCategoryDefaultImage}
        text={item.label}
        badgeText={item.badgeText}
        isSelected={isActive}/>
    );
  }

  return (

    <Container
      overflow={'auto'}
      padding={props.padding}>

      {itemList}
    </Container>
  );
};

ItemSelector.propTypes = {
  padding: PropTypes.string,
  boxShadow: PropTypes.string,
  activeBorder: PropTypes.string,
  inActiveBorder: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]),
      iconUrl: PropTypes.string,
      badgeText: PropTypes.string
    })
  ),
  onChange: PropTypes.func
};

ItemSelector.defaultProps = {
  padding: '5px 0',
  boxShadow: `0px 4px 4px ${CustomColors.TransparentBlack1}`,
  activeBorder: `2px solid ${CustomColors.Blue2}`,
  inActiveBorder: `2px solid ${CustomColors.Transparent}`,
  items: [],
  onChange: () => {}
};
